import { render, staticRenderFns } from "./MedicalContentTemplates.vue?vue&type=template&id=69f526dd&scoped=true&"
import script from "./MedicalContentTemplates.vue?vue&type=script&lang=js&"
export * from "./MedicalContentTemplates.vue?vue&type=script&lang=js&"
import style0 from "./MedicalContentTemplates.vue?vue&type=style&index=0&id=69f526dd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69f526dd",
  null
  
)

export default component.exports